import { useFiles, useWebsiteSettings } from 'client/store'
import { fileType } from 'client/store/files/filesReducer'
import filesSelectors from 'client/store/files/filesSelectors'
import { usePage } from 'client/store/index'
import {
  isWebsitePageType,
  pageSelectors,
} from 'client/store/page/pageSelectors'
import {
  createFontFace,
  entitiesWithFontOptions,
} from 'common/utils/fontsUtils'
import { useEffect } from 'react'
import { getWebsiteStylesAllTypography } from 'src/editor/store/website-settings/website-settings-selector'
import { DataFilesDto } from 'src/server/modules/page/shared/dto/data-file.dto'
import { PageEntityInterface } from 'src/shared/types/base-entity-interface'
import {
  PageCustomFontsGenerator,
  WebsiteCustomFontsGenerator,
} from 'src/shared/utils/custom-fonts-generator'

function useCustomFontFaces() {
  const pageGenerator = new PageCustomFontsGenerator()
  const websiteGenerator = new WebsiteCustomFontsGenerator()

  const globalFontProperties = usePage(page =>
    pageSelectors.getGlobalFontProperties(page),
  )

  const entities = usePage(page =>
    pageSelectors.getEntitiesByTypes(page, entitiesWithFontOptions),
  )

  const fontFiles = useFiles(files =>
    filesSelectors.getFilesByType(files, fileType.font),
  )

  const isWebsitePage = usePage(isWebsitePageType)

  const websiteStylesTypographies = useWebsiteSettings(
    getWebsiteStylesAllTypography,
  )

  useEffect(() => {
    let fontFaces = ''
    if (isWebsitePage) {
      fontFaces = websiteGenerator.generateFonts(
        entities as PageEntityInterface[],
        Object.values(fontFiles) as DataFilesDto,
        websiteStylesTypographies,
      )
    } else {
      fontFaces = pageGenerator.generateFonts(
        entities as PageEntityInterface[],
        Object.values(fontFiles) as DataFilesDto,
        globalFontProperties,
      )
    }

    document.head.appendChild(createFontFace(fontFaces))
  }, [fontFiles])
}

export default useCustomFontFaces
